import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollRestoration } from 'react-router-dom';

export function Layout() {
  const location = useLocation();
  const isTransparent = location.pathname === '/' || location.pathname === '/contact'

  return (
    <div className="min-h-screen">
      <Header transparentAtTop={isTransparent} />
      <main className={isTransparent ? undefined : 'pt-[80px]'}>
        <Outlet />
      </main>
      <Footer />
      <ScrollRestoration />
    </div>
  );
}
